import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';
import './stylesPhone.scss';

export class LanguageSwitcher extends Component {
  static propTypes = {
    onSelect: PropTypes.func,
    showFlags: PropTypes.bool,
    lang: PropTypes.string.isRequired,
  };

  static defaultProps = {
    showFlags: false,
    onSelect: null,
  };

  constructor(props) {
    super(props);

    this.allAvailableLanguages = {
      en: {
        title: 'English',
        flag: '/resources/icons/flags/gb.png',
        id: 'en',
      },
      kr: {
        title: '한국어',
        flag: '/resources/icons/flags/kr.png',
        id: 'kr',
      },
      ru: {
        title: 'Rus',
        flag: '/resources/icons/flags/ru.png',
        id: 'ru',
      },
      tr: {
        title: 'Tur',
        flag: '/resources/icons/flags/tr.png',
        id: 'tr',
      },
      cn: {
        title: '中文',
        flag: '/resources/icons/flags/cn.png',
        id: 'cn',
      },
      id: {
        title: 'Ind',
        flag: '/resources/icons/flags/id.png',
        id: 'id',
      },
      br: {
        title: 'br',
        flag: '/resources/icons/flags/br.png',
        id: 'br',
      },
      de: {
        title: 'de',
        flag: '/resources/icons/flags/de.png',
        id: 'de',
      },
    };

    this.languagesList = process.env.REACT_APP_LANGUAGE_LIST.split(',');

    this.languages = this.getLanguages(this.allAvailableLanguages, this.languagesList);
    this.state = {
      opened: false,
      activeLang: this.setActiveLanguage(),
    };
  }

  getLanguages(allAvailableLanguages, languagesList) {
    const allAvailableLanguagesList = Object.keys(allAvailableLanguages);
    const languages = {};
    languagesList.forEach((language) => { if (allAvailableLanguagesList.indexOf(language) !== -1) { languages[language] = allAvailableLanguages[language] } })
    return (languages);
  }

  setActiveLanguage() {
    const { lang } = this.props;
    const activeLanguage = lang;
    return (activeLanguage);
  }

  renderLanguage(langData, active = false) {
    const {
      showFlags,
      onSelect,
    } = this.props;

    return (
      <div
        key={langData.title}
        className="languageSwitcher__langItem"
        onClick={active ? () => {
        } : () => {
          this.setState({
            activeLang: langData.id,
            opened: false,
          });

          if (onSelect) {
            onSelect(langData.id);
          }
        }
        }
      >
        {showFlags
          && (
            <div className="languageSwitcher__flag">
              <img
                className="languageSwitcher__flag-image"
                src={langData.flag}
                alt=""
              />
            </div>
          )}
        <div className="languageSwitcher__title">
          {langData.title}
        </div>
      </div>
    );
  }

  render() {
    const {
      activeLang,
      opened,
    } = this.state;

    const {
      showFlags,
    } = this.props;

    const classes = classNames('languageSwitcher', {
      'languageSwitcher--opened': opened,
      'languageSwitcher--withFlags': showFlags,
    });

    const listedLangElems = Object.keys(this.languages).filter((langId) => {
      if (langId === activeLang) {
        return false;
      }
      return true;
    });

    const listedLangItems = listedLangElems.map((key) => {
      const langData = this.languages[key];
      return this.renderLanguage(langData);
    });

    return (
      <div
        className={classes}
        onBlur={() => this.setState({
          opened: false,
        })}
        tabIndex="-1"
      >
        <div
          className={classNames('languageSwitcher__current', {
            'languageSwitcher__current--opened': opened,
          })}
          onClick={() => this.setState({
            opened: !opened,
          })}
        >
          {this.renderLanguage(this.languages[activeLang], true)}
        </div>
        <div className="languageSwitcher__list">
          {listedLangItems}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LanguageSwitcher/index.js